import { render, staticRenderFns } from "./LicenciaOficialColectivaComponent.vue?vue&type=template&id=4d5f1114&scoped=true"
import script from "./LicenciaOficialColectivaComponent.vue?vue&type=script&lang=js"
export * from "./LicenciaOficialColectivaComponent.vue?vue&type=script&lang=js"
import style0 from "./LicenciaOficialColectivaComponent.vue?vue&type=style&index=0&id=4d5f1114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f1114",
  null
  
)

export default component.exports